module.exports = __webpack_public_path__ + "img/error-404.df6f16e3.svg";